import React, { useState } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { ChevronDown, ChevronUp, Phone } from 'lucide-react';

// Accordion Komponente für FAQs
const FaqAccordion = ({ question, answer, isOpen, toggle }) => {
  return (
    <div className="border-b border-gray-200 py-4">
      <button
        className="flex justify-between items-center w-full text-left text-lg font-medium text-gray-800 focus:outline-none"
        onClick={toggle}
      >
        <span>{question}</span>
        {isOpen ? 
          <ChevronUp className="h-5 w-5 text-blue-600" /> : 
          <ChevronDown className="h-5 w-5 text-blue-600" />}
      </button>
      <div 
        className={`mt-3 text-gray-600 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96' : 'max-h-0'}`}
      >
        <p className="pb-4">{answer}</p>
      </div>
    </div>
  );
};

const FaqSection = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0);
  
  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  
  const faqs = [
    {
      question: t('businessAppsPage.faq.questions.timeline.question'),
      answer: t('businessAppsPage.faq.questions.timeline.answer'),
    },
    {
      question: t('businessAppsPage.faq.questions.costs.question'),
      answer: t('businessAppsPage.faq.questions.costs.answer'),
    },
    {
      question: t('businessAppsPage.faq.questions.existing.question'),
      answer: t('businessAppsPage.faq.questions.existing.answer'),
    },
    {
      question: t('businessAppsPage.faq.questions.support.question'),
      answer: t('businessAppsPage.faq.questions.support.answer'),
    },
    {
      question: t('businessAppsPage.faq.questions.technology.question'),
      answer: t('businessAppsPage.faq.questions.technology.answer'),
    },
  ];
  
  return (
    <section id="faq" className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            {t('businessAppsPage.faq.title')}
          </h2>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-xl shadow-md p-6 md:p-8 mb-8">
            {faqs.map((faq, index) => (
              <FaqAccordion
                key={index}
                question={faq.question}
                answer={faq.answer}
                isOpen={openIndex === index}
                toggle={() => toggleFaq(index)}
              />
            ))}
          </div>
          
          {/* Telefonkontakt Option */}
          <div className="bg-blue-100 rounded-lg p-4 flex items-center justify-between">
            <div className="flex items-center">
              <Phone className="h-6 w-6 text-blue-600 mr-3" />
              <p className="font-medium text-blue-800">
                {t('businessAppsPage.faq.chatbotText')}
              </p>
            </div>
            <a href="tel:+4922659999775" className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors">
              Jetzt anrufen
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection; 